/**
 * wishlist.js
 * ShopifyでlocalStorageベースのお気に入り機能を共有処理として利用可能にする。
 * 使用方法:
 *   1. テンプレート側でコンテナを用意
 *      <div id="wishlist-contents-{{ card_product.id }}"></div>
 *   2. JSで初期化
 *      initWishlist("wishlist-contents-{{ card_product.id }}", {{ card_product.id }});
 */

(() => {
  const FAVORITE_KEY = 'favoriteProducts';

  /** --- localStorageからお気に入りリストを取得 --- */
  const getFavorites = () => {
    try {
      return JSON.parse(localStorage.getItem(FAVORITE_KEY) || '[]');
    } catch {
      return [];
    }
  };

  /** --- お気に入りを保存 --- */
  const saveFavorites = (favorites) => {
    if (!Array.isArray(favorites)) return;
    localStorage.setItem(FAVORITE_KEY, JSON.stringify(favorites));
  };

  function sanitizeProductId(rawId) {
    // gid://shopify/Product/7902204166243 → 7902204166243
    return String(rawId).replace(/\D+/g, '');
  }

  /** --- 指定したコンテナにウィッシュリストUIを描画 --- */
  function renderWishlistSection(container, productId, type) {
    const cleanId = sanitizeProductId(productId);
    const favorites = getFavorites();
    const isFavorited = favorites.includes(cleanId);

    // UIを描画
    if (type == 'heart') {
      container.innerHTML = `
      <input
        type="hidden"
        class="current-wishlist-id"
        value='${JSON.stringify(favorites)}'
      >

      <img
        class="heart-product add-to-wishlist-heart-${cleanId} ${isFavorited ? 'hide' : ''}"
        src="${window.HEART_ICON_URL.heartWhiteLine}"
        alt="Add to wishlist"
        data-product-id="${cleanId}"
        style="width: 28px; cursor: pointer;"
      >

      <img
        class="heart-product remove-from-wishlist-heart-${cleanId} ${isFavorited ? '' : 'hide'}"
        src="${window.HEART_ICON_URL.heartRed}"
        alt="Remove from wishlist"
        data-product-id="${cleanId}"
        style="width: 28px; cursor: pointer;"
      >
    `;
    } else if (type == 'text') {
      container.innerHTML = `
        <input
          type="hidden"
          class="current-wishlist-id"
          value='${JSON.stringify(favorites)}'
        >
        <div
          class="button button--tertiary underlined-link add-to-wishlist-heart"
          data-product-id="${cleanId}"
          style="margin-top: 1.6rem; text-decoration: underline;"
        >
          お気に入りに追加
        </div>
      `;
    } else if (type == 'product-detail') {
      container.innerHTML = `
        <div
          class="product-card-wrapper heart-wishlist"
          data-product-id="${cleanId}"
        >
          <input
            type="hidden"
            class="current-wishlist-id"
            value='${JSON.stringify(favorites)}'
          >

          <div class="wishlist-icons" style="justify-self: center;">
            <span
              class="svg-wrapper wishlist-heart add-to-wishlist-heart-${cleanId} ${isFavorited ? 'hide' : ''}"
              data-product-id="${cleanId}"
            >
              <img
                class="wishlist-heart add-to-wishlist-heart"
                data-product-id="${cleanId}"
                src="${window.HEART_ICON_URL.heartWhite}"
                alt="Add to wishlist"
                style="width:28px;cursor:pointer;"
              >
            </span>

            <span
              class="svg-wrapper wishlist-heart remove-from-wishlist-heart-${cleanId} ${isFavorited ? '' : 'hide'}"
              data-product-id="${cleanId}"
            >
              <img
                class="wishlist-heart remove-from-wishlist-heart"
                data-product-id="${cleanId}"
                src="${window.HEART_ICON_URL.heartRed}"
                alt="Remove from wishlist"
                style="width:28px;cursor:pointer;"
              >
            </span>
          </div>
        </div>
      `;
    }

    /** --- ボタン要素を取得 --- */
    const addBtn = container.querySelector(`.add-to-wishlist-heart-${cleanId}`);
    const removeBtn = container.querySelector(`.remove-from-wishlist-heart-${cleanId}`);
    // const countEl = container.querySelector('.wishlist-count__number');

    /** --- localStorage更新 --- */
    const updateLocalStorage = (newList) => {
      saveFavorites(newList);
      // countEl.textContent = newList.length;
    };

    /** --- UI更新 --- */
    const updateUI = (inList) => {
      addBtn.classList.toggle('hide', inList);
      removeBtn.classList.toggle('hide', !inList);
    };

    /** --- お気に入り追加 --- */
    addBtn.addEventListener('click', () => {
      let list = getFavorites();
      if (!list.includes(cleanId)) {
        list.push(cleanId);
        updateLocalStorage(list);
        updateUI(true);
      }
    });

    /** --- お気に入り解除 --- */
    removeBtn.addEventListener('click', () => {
      let list = getFavorites();
      list = list.filter((id) => id !== cleanId);
      updateLocalStorage(list);
      updateUI(false);
    });
  }

  /** --- 外部から呼び出せる初期化関数 --- */
  window.initWishlist = function (containerId, productId, type) {
    const container = document.getElementById(containerId);
    if (!container || !productId) return;
    renderWishlistSection(container, productId, type);
  };

  // window.initAllWishlistMarks = function () {
  //   const favorites = getFavorites();
  //   if (favorites.length === 0) return;

  //   favorites.forEach((id) => {
  //     // 商品カード内の一致するボタンを取得
  //     const addBtn = document.querySelector(`.add-to-wishlist-heart-${id}`);
  //     const removeBtn = document.querySelector(`.remove-from-wishlist-heart-${id}`);
  //     if (addBtn && removeBtn) {
  //       addBtn.classList.add('hide');
  //       removeBtn.classList.remove('hide');
  //     }
  //   });
  // };
  // document.addEventListener('DOMContentLoaded', () => {
  //   window.initAllWishlistMarks();
  // });
})();
